import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import { useIsMobile } from '../../hooks/useResponsive';

const GOLD = '#C9A96E';
const VD   = '#6D28D9';
const sans  = "'Montserrat', sans-serif";
const serif = "'Cormorant Garamond', Georgia, serif";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { itemCount }    = useCart();
  const navigate         = useNavigate();
  const location         = useLocation();
  const isMobile         = useIsMobile();

  const links = [
    { to: '/',                l: 'Accueil' },
    { to: '/catalogue',       l: 'Catalogue' },
    { to: '/suivi-commandes', l: 'Suivi' },
  ];

  const active = (to) => to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <nav style={{
      background: '#fff',
      borderBottom: '1px solid #F0ECFF',
      position: 'sticky', top: 0, zIndex: 200,
      boxShadow: '0 2px 12px rgba(109,40,217,0.07)',
    }}>
      {/* Ligne principale */}
      <div style={{
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        padding: isMobile ? '0 1rem' : '0 2rem',
        height: isMobile ? 56 : 68,
        gap: isMobile ? 8 : 0,
      }}>

        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          <img
            src="/logo-banner.jpeg"
            alt="SS Parfumerie"
            style={{ height: isMobile ? 38 : 44, width: isMobile ? 38 : 44, borderRadius: '50%', objectFit: 'cover', objectPosition: 'center' }}
          />
          {!isMobile && (
            <div>
              <p style={{ fontFamily: sans, fontSize: 13, fontWeight: 700, color: VD, letterSpacing: 3, lineHeight: 1, textTransform: 'uppercase' }}>SS</p>
              <p style={{ fontFamily: sans, fontSize: 8, letterSpacing: 3, color: GOLD, textTransform: 'uppercase', fontWeight: 600, marginTop: 2 }}>Parfumerie</p>
            </div>
          )}
        </Link>

        {/* Liens nav — toujours visibles */}
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 4 : 32, flex: 1, justifyContent: 'center' }}>
          {links.map(({ to, l }) => (
            <Link key={to} to={to} style={{
              fontFamily: sans,
              fontSize: isMobile ? 10 : 11,
              letterSpacing: isMobile ? 1 : 2,
              textTransform: 'uppercase',
              textDecoration: 'none',
              color: active(to) ? VD : '#777',
              fontWeight: active(to) ? 700 : 400,
              borderBottom: active(to) ? `2px solid ${GOLD}` : '2px solid transparent',
              paddingBottom: 2,
              whiteSpace: 'nowrap',
            }}>
              {l}
            </Link>
          ))}
        </div>

        {/* Actions droite */}
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 6 : 10, flexShrink: 0 }}>
          {!isMobile && (
            <a href="tel:+221773769621" style={{
              textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 5,
              background: '#FFF8F0', border: '1px solid #F5DEB3', borderRadius: 20, padding: '5px 12px',
            }}>
              <span style={{ fontSize: 12 }}>📞</span>
              <span style={{ fontFamily: sans, fontSize: 11, color: GOLD, letterSpacing: 1, fontWeight: 600 }}>+221 77 376 96 21</span>
            </a>
          )}

          {user ? (
            <>
              {!isMobile && (
                <Link to="/mes-commandes" style={{ fontFamily: sans, fontSize: 11, color: '#555', textDecoration: 'none', letterSpacing: 1, fontWeight: 600 }}>
                  {user.name.split(' ')[0]}
                </Link>
              )}
              <button onClick={() => { logout(); navigate('/'); }} style={{
                background: 'transparent', border: '1px solid #E9E4FF', color: '#888',
                padding: isMobile ? '6px 8px' : '7px 14px',
                fontSize: isMobile ? 9 : 10, letterSpacing: 1, textTransform: 'uppercase',
                cursor: 'pointer', fontFamily: sans, borderRadius: 4,
              }}>
                {isMobile ? '⎋' : 'Déco'}
              </button>
            </>
          ) : (
            <Link to="/login" style={{
              background: 'transparent', border: `1px solid ${GOLD}`, color: VD,
              padding: isMobile ? '6px 10px' : '7px 16px',
              fontSize: isMobile ? 9 : 10, letterSpacing: 1, textTransform: 'uppercase',
              fontFamily: sans, fontWeight: 700, textDecoration: 'none', display: 'inline-block',
              borderRadius: 4,
            }}>
              {isMobile ? '👤' : 'Connexion'}
            </Link>
          )}

          <Link to="/panier" style={{
            background: VD, color: '#fff',
            padding: isMobile ? '7px 10px' : '8px 18px',
            fontSize: isMobile ? 9 : 10, letterSpacing: 1,
            textTransform: 'uppercase', fontFamily: sans, fontWeight: 700,
            textDecoration: 'none', display: 'inline-block', borderRadius: 4,
            whiteSpace: 'nowrap',
          }}>
            {isMobile ? `🛒${itemCount > 0 ? ` ${itemCount}` : ''}` : `Panier${itemCount > 0 ? ` (${itemCount})` : ''}`}
          </Link>
        </div>
      </div>
    </nav>
  );
}
